
document.addEventListener('DOMContentLoaded', function () {
	const popup = document.getElementById('cw-youtube-popup');
	if (!popup) return;

	const iframe = document.getElementById('cw-youtube-popup-iframe');
	const image = document.getElementById('cw-youtube-popup-image');
	const closeBtn = popup.querySelector('.cw-youtube-popup__close');
	const youtubeTriggers = document.querySelectorAll('.youtube-pop');
	const imageTriggers = document.querySelectorAll('.image-popup');

	function openPopup(videoId) {
		if (!videoId) return;

		popup.classList.remove('is-image');
		popup.classList.add('is-video');
		if (image) {
			image.src = '';
			image.alt = '';
		}

		iframe.src = 'https://www.youtube.com/embed/' + encodeURIComponent(videoId) + '?autoplay=1&rel=0';
		popup.classList.add('is-active');
		popup.setAttribute('aria-hidden', 'false');
		document.body.classList.add('cw-youtube-popup-open');
	}

	function openImagePopup(imageSrc, imageAlt) {
		if (!imageSrc || !image) return;

		iframe.src = '';
		popup.classList.remove('is-video');
		popup.classList.add('is-image');
		image.src = imageSrc;
		image.alt = imageAlt || '';
		popup.classList.add('is-active');
		popup.setAttribute('aria-hidden', 'false');
		document.body.classList.add('cw-youtube-popup-open');
	}

	function closePopup() {
		popup.classList.remove('is-active');
		popup.classList.remove('is-video');
		popup.classList.remove('is-image');
		popup.setAttribute('aria-hidden', 'true');
		iframe.src = '';
		if (image) {
			image.src = '';
			image.alt = '';
		}
		document.body.classList.remove('cw-youtube-popup-open');
	}

	youtubeTriggers.forEach(function (trigger) {
		trigger.addEventListener('click', function () {
			const videoId = this.getAttribute('data-video-id');
			openPopup(videoId);
		});
	});

	imageTriggers.forEach(function (trigger) {
		trigger.addEventListener('click', function () {
			const imageSrc = this.getAttribute('data-image-src');
			const imageAlt = this.getAttribute('data-image-alt');
			openImagePopup(imageSrc, imageAlt);
		});
	});

	if (closeBtn) {
		closeBtn.addEventListener('click', closePopup);
	}

	document.addEventListener('keydown', function (e) {
		if (e.key === 'Escape') {
			closePopup();
		}
	});
});
